import { Box, Flex, HStack, Heading } from "@chakra-ui/react";

export type InfoCardProps = {
  title?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
};

const InfoCard: React.FC<InfoCardProps> = ({ title, icon, rightSlot, children }) => {
  return (
    <Box
      bg="white"
      borderRadius="18px"
      boxShadow="0 10px 25px rgba(18, 18, 18, 0.06)"
      borderWidth="1px"
      borderColor="#EFE7E7"
      overflow="hidden"
    >
      {(title || rightSlot) ? (
        <Flex
          px={{ base: 3, sm: 4, md: 6 }}
          py={{ base: 3, sm: 4, md: 5 }}
          align="center"
          justify="space-between"
          gap={3}
        >
          <HStack spacing={2} minW={0}>
            {icon ? (
              <Flex
                w="30px"
                h="30px"
                align="center"
                justify="center"
                borderRadius="10px"
                bg="#FFF3E8"
                color="#E35E00"
                flexShrink={0}
              >
                {icon}
              </Flex>
            ) : null}
            {title ? (
              <Heading fontSize={{ base: "20px", md: "25px" }} color="#2b1b1a" noOfLines={1} fontWeight="800">
                {title}
              </Heading>
            ) : null}
          </HStack>
          {rightSlot ? <Box flexShrink={0}>{rightSlot}</Box> : null}
        </Flex>
      ) : null}

      <Box px={{ base: 3, sm: 4, md: 6 }} pb={{ base: 3, sm: 4, md: 6 }}>
        {children}
      </Box>
    </Box>
  );
};

export default InfoCard;
